import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const event = useConnect('event.byId', {
    id: Number(match.params.eventId)
  })

  if (event.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      event={event}
      page="Location"
      title="Will this event occur in-person, virtually, or is it flexible?"
    >
      <Form
        user={user}
        event={event}
        navigation={(
          <Navigation v5={true} activeStep={12} steps={13}/>
        )}
        onPrevious={(newData) => history.push(Urls(event).TIME)}
        onNext={(newData) => history.push(Urls(event).DOCUMENTS)}
        onSkip={() => history.push(Urls(event).DOCUMENTS)}
        onExit={() => history.push(Urls(event).EVENT_EDIT)}
      />
    </ParentLayout>
  );
};
